import Icon from '../components/Icon.vue'

Icon.register({
  'code-branch': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M384 144C384 99.8 348.2 64 304 64S224 99.8 224 144C224 180.4 248.3 211.1 281.5 220.8 280.9 236.9 277.3 249.3 270.5 257.7 255.1 276.9 221.2 280.1 185.3 283.4 157.1 286 127.9 288.8 104 300.3V156.3C136.5 146.1 160 115.8 160 80 160 35.8 124.2 0 80 0S0 35.8 0 80C0 115.8 23.5 146.1 56 156.3V355.6C23.5 365.9 0 396.2 0 432 0 476.2 35.8 512 80 512S160 476.2 160 432C160 398 138.8 368.9 108.8 357.4 111.9 352.2 116.6 347.6 123.7 344 139.9 335.8 164.1 333.6 189.8 331.2 232 327.3 279.8 322.8 308 287.8 322 270.4 329.1 248 329.6 219.9 361.2 209.1 384 179.2 384 144zM80 64C88.8 64 96 71.2 96 80S88.8 96 80 96 64 88.8 64 80 71.2 64 80 64zM80 448C71.2 448 64 440.8 64 432S71.2 416 80 416 96 423.2 96 432 88.8 448 80 448zM304 128C312.8 128 320 135.2 320 144S312.8 160 304 160 288 152.8 288 144 295.2 128 304 128z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/code-branch.js
// module id = DfP9
// module chunks = 144